import React, { useState, useEffect } from "react";
import "./Registration.css";
import Step1 from "./step1/Step1";
import Step2 from "./step2/Step2";
import Step3 from "./step3/Step3";
import Step4 from "./step4/Step4";
import Step5 from "./step5/Step5";
import Step6 from "./step6/Step6";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHouse } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

function Registration() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [step, setStep] = useState(1);

  const [segmentSuited, setSegmentSuited] = useState("");
  const [enrollStudents, setEnrollStudents] = useState("");
  const [annualIntake, setAnnualIntake] = useState("");

  const [Institute, setInstitute] = useState("");
  const [obstacle, setObstacle] = useState("");

  const next = () => step < 6 && setStep(step + 1);
  const back = () => step > 1 && setStep(step - 1);

  const renderStep = () => {
    switch (step) {
      case 1:
        return (
          <Step1
            next={next}
            setSegmentSuited={setSegmentSuited}
            segmentSuited={segmentSuited}
          />
        );
      case 2:
        return (
          <Step2
            next={next}
            back={back}
            enrollStudents={enrollStudents}
            setEnrollStudents={setEnrollStudents}
          />
        );
      case 3:
        return (
          <Step3
            next={next}
            back={back}
            setAnnualIntake={setAnnualIntake}
            annualIntake={annualIntake}
          />
        );
      case 4:
        return (
          <Step4
            next={next}
            back={back}
            setObstacle={setObstacle}
            obstacle={obstacle}
          />
        );
      case 5:
        return (
          <Step5
            next={next}
            back={back}
            setInstitute={setInstitute}
            Institute={Institute}
          />
        );
      case 6:
        return (
          <Step6
            back={back}
            
            enrollStudents={enrollStudents}
           
            segmentSuited={segmentSuited}
            
            annualIntake={annualIntake}
           
            obstacle={obstacle}
         
            Institute={Institute}
          />
        );
      default:
        return <Step1 next={next} />;
    }
  };

  return (
    <>
      <section className="container">
        <div className="registration_main">
          {renderStep()}
          <Link to="/">
            <div className="back_btn_holder">
              <FontAwesomeIcon className="home_icon" icon={faHouse} />
            </div>
          </Link>
        </div>
      </section>
    </>
  );
}

export default Registration;
